<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="recordList"
      :search="search" class="elevation-1" 
      :loading="loading"
      :sort-by="sortBy"
      :page.sync="page"
      @page-count="pageCount = $event"
      loading-text="Loading... Please wait"
    >
      <template v-slot:top>

        <v-toolbar flat>
          <v-toolbar-title>Subject</v-toolbar-title>
          <v-divider class="mx-4" inset vertical /> 
          <v-spacer />

          <v-dialog v-model="dialogExport" max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" class="mb-2" v-bind="attrs" v-on="on" ><v-icon>mdi-export</v-icon> Export</v-btn>
          </template>
          <v-card>

            <v-card-title>
              <span class="headline">Export</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form v-bind:disabled="loading" lazy-validation ref="dialogForm">
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="selectedSCGEmployeeForExport"
                        :items="employeeTypeArrayForExport"
                        item-text="value"
                        item-value="key"
                        label="SCG Employee"
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="loading" color="blue darken-1" text @click="closeExport">Cancel</v-btn>
              <v-btn :disabled="loading" color="blue darken-1" text @click="exportData">Export</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

          <v-btn text icon class="mb-2 ml-2" @click="initialize">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          
        </v-toolbar>
      </template>

      <template v-slot:[`body.prepend`]="{ headers }">
          <tr class="mx-0 px-0">
            <td :colspan="headers.length" class="mx-0 px-0">
              <v-text-field  v-model="search" prepend-inner-icon="mdi-magnify" label="Search" single-line hide-details filled class="px-0 mx-0"/>
            </td>
          </tr>
      </template>

      <template v-slot:[`item.lineId`]="{ item }">
        <copy-to-clipboard :text="item.lineId" @copy="showInfoSnack('Copied Line token to clipboard')">
          <v-icon small style="cursor: pointer">mdi-content-copy</v-icon>
        </copy-to-clipboard>
      </template>

      <template v-slot:[`item.history`]="{ item }">
        <template v-if="hasAnswers(item.history)">
          <v-btn
            color="primary"
            small
            @click="viewAnswer(item.history, 'History')"
          >
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <span>-</span>
        </template>
      </template>

      <template v-slot:[`item.vaccine`]="{ item }">
        <template v-if="hasAnswers(item.vaccine)">
          <v-btn
            color="primary"
            small
            @click="viewAnswer(item.vaccine, 'Vaccine')"
          >
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <span>-</span>
        </template>
      </template>

      <template v-slot:[`item.symptom`]="{ item }">
        <template v-if="hasAnswers(item.symptom)">
          <v-btn
            color="primary"
            small
            @click="viewAnswer(item.symptom, 'Symptom')"
          >
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <span>-</span>
        </template>
      </template>

      <template  v-slot:[`item.status`]="{ item }" >
        <template v-if="item.profile.status === 'new' || item.profile.status === ''">
          <v-btn color="success" small @click="approve(item)">
            <small><v-icon small>mdi-check</v-icon>&nbsp; Approve</small>
          </v-btn>&nbsp;
          <!--<v-btn color="error" small @click="reject(item)">
            <small><v-icon small>mdi-close</v-icon>&nbsp; Reject</small>
          </v-btn>-->
        </template>
        <template v-else>
          <span :class="{'success--text': item.profile.status === 'approve', 'error--text': item.profile.status === 'reject'}">
            <template v-if="item.profile.status === 'approve'">
              <v-icon color="success" small>mdi-shield-check-outline</v-icon>
            </template>&nbsp;
            <strong>{{ item.profile.status === 'approve' ? 'Approved' : 'Rejected' }}</strong>
          </span>
        </template>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="20"
      ></v-pagination>
    </div>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" text @click="snack = false">Close</v-btn>
        </template>
    </v-snackbar>

    <v-snackbar v-model="snackLoading" :timeout="-1" color="success">
      Loading...
    </v-snackbar>

    <v-dialog v-model="dialogViewAnswer" max-width="1100px">
      <v-card>

        <v-card-title>
          <span class="headline">View {{ viewAnswerType }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form v-bind:disabled="loading" lazy-validation ref="dialogForm">
              <v-row>
                <template v-for="(question, index) in Object.keys(questions)">
                  <v-col
                    cols="8"
                    v-if="viewAnswerData[question]"
                    v-bind:key="`question_${index}`"
                  >
                    {{ questions[question] }}
                  </v-col>
                  <v-col
                    cols="4"
                    v-if="viewAnswerData[question]"
                    v-bind:key="`answer_${index}`"
                    class="text-right"
                  >
                    <template v-if="question === 'vQ6Year'">
                      {{ (viewAnswerData['vQ6Day'] ? viewAnswerData['vQ6Day'] : '-') + '/' + viewAnswerData['vQ6Month'] + '/' +viewAnswerData['vQ6Year'] }}
                    </template>
                    <template v-else>
                      {{ viewAnswerData[question] === 'Y' ? 'ใช่' : (viewAnswerData[question] === 'N' ? 'ไม่ใช่' : viewAnswerData[question]) }}
                    </template>
                  </v-col>
                </template>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="loading" color="blue darken-1" text @click="dialogViewAnswer = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import CopyToClipboard from 'vue-copy-to-clipboard'

export default {
  components: {
    CopyToClipboard
  },
  data() {
    return {
      recordList: [],
      sortBy: ['rCode'],
      snack: false,
      snackColor: '',
      snackText: '',
      snackLoading: false,
      search: '',
      loading: true,

      page: 1,
      pageCount: 0,

      dialog: false,
      dialogViewAnswer: false,
      dateDobShow: false,
      dateShow: false,
      timeShow: false,

      dialogExport: false,
      selectedSCGEmployeeForExport: 'all',

      viewAnswerType: '',
      viewAnswerData: {},

      rules: {
        required: value => !!value || 'Required.',
        number: value => {
          const pattern = /^[\d]+$/
          return (pattern.test(value) && parseInt(value) >= 1 && parseInt(value) <= this.numberOfRound) || `Only number in range 1 - ${this.numberOfRound}`
        }
      },

      headers: [
        {
          text: "Code",
          align: "center",
          sortable: true,
          value: "rCode"
        },
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "name"
        },
        {
          text: "Citizen ID",
          align: "center",
          sortable: true,
          value: "id"
        },
        {
          text: "Line",
          align: "center",
          sortable: false,
          value: "lineId"
        },
        {
          text: "SCG Employee",
          align: "center",
          sortable: true,
          value: "is_scg"
        },
        {
          text: "Gender",
          align: "center",
          sortable: true,
          value: "gender"
        },
        {
          text: "Blood Group",
          align: "center",
          sortable: true,
          value: "b"
        },
        {
          text: "History",
          align: "center",
          sortable: false,
          value: "history"
        },
        {
          text: "Vaccine",
          align: "center",
          sortable: false,
          value: "vaccine"
        },
        {
          text: "Symptom",
          align: "center",
          sortable: false,
          value: "symptom"
        },
        {
          text: "Approve",
          align: "center",
          sortable: true,
          value: "status"
        },
      ],
      editedItem: {
        lineId: '',
        history: {
          key: ''
        },
        profile: {
          fName: '',
          lName: '',
        },
        symptom: {
          key: ''
        },
        vaccine: {
          key: ''
        },
      },
      defaultItem: {
        lineId: '',
        history: {
          key: ''
        },
        profile: {
          fName: '',
          lName: '',
          age: '',
          birthDate: '',
          bloodType: '',
          gender: '',
          idCard: '',
          tel: ''
        },
        symptom: {
          key: ''
        },
        vaccine: {
          key: ''
        },
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedItem.lineId === this.defaultItem.lineId ? "New User" : "Edit User";
    },
    ...mapGetters({
      employeeTypes: 'constant/employeeTypes',
      questions:  'constant/questions',
      bloodGroups: 'constant/bloodGroups',
      genders: 'constant/genders',
    }),
    employeeTypeArray() {
      return Object.keys(this.employeeTypes).map(key => {
        return {
          key: key,
          value: this.employeeTypes[key]
        }
      });
    },
    employeeTypeArrayForExport() {
      return [
        {
          key: 'all',
          value: 'All'
        },
        {
          key: 'scg_only',
          value: 'พนักงาน SCG เท่านั้น'
        },
        {
          key: 'scg_and_other',
          value: 'พนักงาน SCG และในเครือ'
        },
        ...this.employeeTypeArray
      ];
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
        this.loading = true;
        try {
          await this.loadUser()
        } catch (e) {
          console.error(e);
        }
        this.loading = false;
    },
    async loadUser() {
      this.showLoadingSnack();

      const dbRef = this.$firebase.database().ref('immunity/user')
      this.recordList = []
      dbRef.once('value').then((snapshot) => {
        snapshot.forEach((snap) => {
          const val = snap.val();

          if (val && val.profile && 'status' in val.profile === false) {
            val.profile.status = 'new';
          }

          var vaccineDate1 = '';
          var vaccineDate2 = '';
          var vaccineDate3 = '';

          if (val.vaccine && val.vaccine.vQ4) {
            if (val.vaccine.vQ4 === '1') {
              vaccineDate1 = val.vaccine.vQ2a;
            } else if (val.vaccine.vQ4 === '2') {
              if (val.vaccine.vQ5) {
                vaccineDate1 = val.vaccine.vQ5;
                vaccineDate2 = val.vaccine.vQ2a;
              } else {
                vaccineDate2 = val.vaccine.vQ2a;
              }
            } else if (val.vaccine.vQ4 === '3') {
              vaccineDate1 = val.vaccine.vQ5 || '';
              vaccineDate2 = val.vaccine.vQ9 || '';
              vaccineDate3 = val.vaccine.vQ2a ;
            }
          }

          this.recordList.push(
            Object.assign({},
            this.defaultItem,
            {
              ...val,
              lineId: snap.key,
              name: this.$options.filters.profileName(val.profile) ?? '-',
              gender: val.profile.gender ?? '-',
              id: this.$options.filters.blankOrDash(val.profile.idCard),
              b: this.$options.filters.blankOrDash(val.profile.bloodType),
              status: val.profile.status ?? '',
              rCode: val.profile.rCode ?? '-',
              is_scg: this.employeeType(val.profile),
              vaccineDate1,
              vaccineDate2,
              vaccineDate3
            }));
        })

        this.hideLoadingSnack();
      })
    },
    hasAnswers (data) {
      return data && Object.keys(data).filter(e => e !== 'key').length > 0;
    },
    viewAnswer(data, type) {
      this.viewAnswerType = type;
      this.viewAnswerData = data;
      this.dialogViewAnswer = true;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    age(profile) {
      // birthDate
      if (profile.birthDate) {
        const ageDifMs = Date.now() - (new Date(profile.birthDate));
        const ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
      } else if (profile.age) {
        return profile.age;
      }
      return '';
    },

    async approve(item, isApprove = true) {
      this.loading = true;
      try {
        const error = (e) => {
          this.loading = false;
          this.close();

          this.snack = true
          this.snackColor = 'error'
          this.snackText = 'Error ' + e.message
        }

        const keyItem = item.lineId
        let data = Object.assign({}, item);

        // remove temp data
        delete data.b;
        delete data.id;
        delete data.name;
        delete data.status;
        delete data.gender;
        delete data.is_scg;
        delete data.lineId;
        delete data.rCode;
        delete data.vaccineDate1;
        delete data.vaccineDate2;
        delete data.vaccineDate3;

        data.profile.status = isApprove ? 'approve' : 'reject';

        // set status to approve
        this.$firebase.database().ref('immunity/user/' + keyItem)
          .update(data)
          .then(() => {
            // duplicate to /blood
            let profile = Object.assign({}, data.profile);
            profile.age = this.age(profile);
            let duplicateData = {
              profile,
              uid: item.lineId
            };

            this.$firebase.database().ref(`immunity/blood/${profile.idCard}`)
              .update(duplicateData)
              .then(() => {
                this.loading = false;
                this.close();

                this.snack = true
                this.snackColor = 'success'
                this.snackText = 'Save success'
                this.loadUser()
              })
              .catch(error)
          }).catch(error)
      } catch (e) {
        this.loading = false;
        this.close();

        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Error ' + e.message

        console.error(e);  
      }
      this.loading = false;
    },
    async reject(item) {
      this.approve(item, false);
    },
    showInfoSnack (message) {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = message
    },
    employeeType (profile) {
      if (!profile || 'pQ1' in profile === false) {
        return '-';
      }

      return this.employeeTypes[profile.pQ1] ?? '[invalid]';
    },
    closeExport() {
      this.selectedSCGEmployeeForExport = this.employeeTypeArrayForExport[0];
      this.dialogExport = false;
    },
    exportData() {
      var exportList = []
      this.recordList.forEach(e => {
        var pass = true;
        if (this.selectedSCGEmployeeForExport === 'all') {
          // pass
        } else if (this.selectedSCGEmployeeForExport === 'scg_only') {
          pass =
            e.profile.pQ1 === 'CBM' ||
            e.profile.pQ1 === 'CHEM' ||
            e.profile.pQ1 === 'PACK' ||
            e.profile.pQ1 === 'CAFI';
        } else if (this.selectedSCGEmployeeForExport === 'scg_and_other') {
          pass =
            e.profile.pQ1 === 'CBM' ||
            e.profile.pQ1 === 'CHEM' ||
            e.profile.pQ1 === 'PACK' ||
            e.profile.pQ1 === 'CAFI' ||
            e.profile.pQ1 === 'OTHER';
        } else if (['CBM', 'CHEM', 'PACK', 'CAFI', 'OTHER'].indexOf(this.selectedSCGEmployeeForExport) !== -1) {
          pass = e.profile.pQ1 === this.selectedSCGEmployeeForExport;
        } else {
          pass = ['CBM', 'CHEM', 'PACK', 'CAFI', 'OTHER'].indexOf(e.profile.pQ1 ?? '') === -1;
        }

        if (pass) {
          const vQ6 = e.vaccine.vQ6 ? (e.vaccine.vQ6 === 'Y' ? 'Yes' : 'No') : ('');
          var vQ6Date = '';
          if (vQ6 === 'Yes') {
            vQ6Date = `${e.vaccine.vQ6Day ?? '-'}/${e.vaccine.vQ6Month}/${e.vaccine.vQ6Year}`;
          }

          exportList.push([
            e.profile.rCode ?? '',
            e.profile.fName ?? '-',
            e.profile.lName ?? '-',
            e.is_scg ?? '-',
            e.profile.idCard ?? '-',
            e.profile.tel ?? '-',
            e.profile.birthDate ?? '-',
            e.profile.gender ?? '-',
            e.profile.bloodType ?? '-',
            e.profile.status === 'approve' ? 'Approved' : 'Waiting',
            vQ6,
            vQ6Date,
            e.vaccine.vQ2 === 'Y' ? 'Yes' : 'No',
            e.vaccine.vQ4 ?? '',
            e.vaccineDate1,
            e.vaccine.vQ3  ?? '',
            e.vaccineDate2,
            e.vaccine.vQ7  ?? '',
            e.vaccineDate3,
            (e.vaccine.vQ4 && e.vaccine.vQ4==3)?e.vaccine.vQ10  ?? '':'',
            !e.vaccine.vQ12?'N/A':(e.vaccine.vQ12 === 'Y' ? 'Yes' : 'No'),
            e.vaccine.vQ13 ?? '-',
            !e.vaccine.vQ14?'N/A':(e.vaccine.vQ14 === 'Y' ? 'Yes' : 'No'),
            e.vaccine.vQ15 ?? '-',
          ]);
        }
      });

      if (exportList.length === 0) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'no data to export, please change your date range and try again';
      } else {
        var headers = [
          // Profile
          'code',
          'firstname',
          'lastname',
          'SCG employee',
          'id card',
          'tel',
          'dob',
          'gender',
          'blood group',
          'approve',
          'tested positive',
          'tested date',
          'vaccined',
          'total vaccined',
          'first vaccined date',
          'first vaccine type',
          'second vaccined date',
          'second vaccine type',
          'third vaccined date',
          'third vaccine type',
          'medicine',
          'medicine answer',
          'congenital disease',
          'congenital disease answer',
        ];

        let data = headers.join(',') + '\n';

        exportList.sort((a, b) => {
          return (parseInt(a[0]) || 0) - (parseInt(b[0]) || 0);
        });

        exportList.forEach(e => {
          data += e.map(ee => {
            return '"' + `${ee}`.replace('"', '\\"') + '"';
          }).join(',') + '\n';
        });

        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
        element.setAttribute('download', 'download.csv');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

        this.snack = true
        this.snackColor = 'success'
        this.snackText = `${exportList.length} records exported successful`;

        this.dialogExport = false;
      }
    },
    showLoadingSnack () {
      this.snackLoading = true;
    },
    hideLoadingSnack () {
      this.snackLoading = false;
    },
  },
  filters: {
    profileName: function(profile) {
      if (!profile) {
        return '-';
      }

      var name = profile.fName;
      if (name && profile.lName) {
        name += ` ${profile.lName}`;
      } else if (profile.lName) {
        name = profile.lName;
      }
      
      return name ?? '-';
    },
    blankOrDash: function (text) {
      if (!text || text === '') {
        return '-';
      }
      return text;
    }
  }
};
</script>